import React from "react";
import {
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SearchTableRow from "./SearchTableRow";

const StyledTableContainer = styled(TableContainer)`
  margin-top: 1em;
`;

const UsersTable = ({
  usersList,
}) => {
  return (
    <StyledTableContainer>
      <Table size="small" aria-label="user table">
        <TableHead>
          <TableRow>
            <TableCell>Last Name</TableCell>
            <TableCell align="right">First Name</TableCell>
            <TableCell align="right">Email</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {usersList.map(
            (user) => <SearchTableRow
              key={user.userEmailEntityId}
              user={user}
            />,
          )}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default UsersTable;
